import { render, staticRenderFns } from "./StarPrinterSettings.vue?vue&type=template&id=313408f2&"
import script from "./StarPrinterSettings.vue?vue&type=script&lang=js&"
export * from "./StarPrinterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports